import { ActionTypes } from "../contants/action-types";

const initialState = {
    funds:[]
}

export const fundsReducer = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.GET_FUNDS:
        //   return {...state, chartofAcconts:payload};
          return payload;
        default:
          return state;
    }

}